import React from 'react';
import { Button, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { keycloakRef } from '../KeycloakProvider';

const StyledContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
const StyledInnerContainer = styled.div`
    text-align: center;
    max-width: 560px;
`;
const StyledH1 = styled(Typography)`
    font-size: 2.2rem;
    font-weight: 700;
    margin-bottom: 1rem;
`;

function NoAccess() {
    return (
        <StyledContainer>
            <StyledInnerContainer>
                <StyledH1 variant="h1">No Access</StyledH1>
                <Typography>
                    You do not have the correct access rights yet for these pages.
                    If you think you should have access, please contact
                    support at <a
                        href="mailto:support@selflystore.com"
                        target="_blank"
                        rel="noreferrer"
                    >support@selflystore.com</a>.
                </Typography>
                <p />
                <Button
                    onClick={() => {
                        keycloakRef.current.logout();
                    }}
                >
                    Log out
                </Button>
            </StyledInnerContainer>
        </StyledContainer>
    );
}

export default NoAccess;
